(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /*
    Sticky header, like the old flooringsurgeons.co.uk header (its theme bundle, read 24 Sep 2026):
    - the white card / mobile bar stays pinned (position: sticky – desktop sticks at -24px so the gap above the card
      scrolls off, exactly like the old padding 24 → 0);
    - past 50px of scroll the card goes full width (.is-scrolled);
    - scrolling down (> 4px) hides the second row – the grey menu bar on desktop, the search field on phones
      (.is-row-hidden); scrolling up brings the grey bar back (phones: back at the top, or from the search icon).
    Only opacity / transform / visibility change, so nothing below the header ever moves (no layout shift).
    Publishes --fs-sticky-header-h (visible pinned height) on <html> for sticky PDP columns, TOC and anchors.
  */
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      if (!this.header) return;
      this.type = this.getAttribute('data-sticky-type') || 'on-scroll-up';
      this.desktop = window.matchMedia('(min-width: 990px)');
      this.lastY = window.scrollY;
      this.ticking = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.header.classList.add('fs-hdr-pinned');
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.update = this.update.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.desktop.addEventListener('change', this.update);
      /* Speed (12 Oct 2026): the first measure runs in the ResizeObserver's first callback (after the browser's own
         layout, before paint) instead of forcing a layout of the whole page at start-up. Same values, same frame. */
      if ('ResizeObserver' in window) {
        let first = true;
        this.resizeObserver = new ResizeObserver(() => {
          this.setHeaderHeight();
          this.publishOffset();
          if (first) { first = false; this.update(); }
        });
        this.resizeObserver.observe(this);
      } else {
        this.setHeaderHeight();
        this.update();
      }
      // fs-pdp.js / fs-article.js set the offset once at start-up; publish ours after them.
      window.addEventListener('load', () => this.publishOffset(), { once: true });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      this.desktop?.removeEventListener('change', this.update);
      this.resizeObserver?.disconnect();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(this.update);
    }

    // Distance from the top of the page to the header (the offers strip above it scrolls away first).
    startY() {
      let y = 0;
      let el = this.header.previousElementSibling;
      while (el) {
        if (el.classList.contains('shopify-section')) y += el.offsetHeight;
        el = el.previousElementSibling;
      }
      return y;
    }

    update() {
      this.ticking = false;
      const y = Math.max(0, window.scrollY);
      const delta = y - this.lastY;
      const desktop = this.desktop.matches;
      const busy =
        this.preventHide || // a mega menu is open (set by header-menu in details-disclosure.js)
        this.header.classList.contains('menu-open') ||
        this.classList.contains('is-search-open') ||
        [...this.predictiveSearches].some((search) => search.isOpen);

      if (y <= this.startY() + 50) {
        this.classList.remove('is-scrolled');
        this.setRowHidden(false);
      } else {
        this.classList.add('is-scrolled');
        if (this.type !== 'always' && this.type !== 'reduce-logo-size') {
          if (delta > 4 && !busy) this.setRowHidden(true);
          else if (delta < -4 && desktop) this.setRowHidden(false);
        }
      }
      this.lastY = y;
    }

    setRowHidden(hide) {
      if (this.classList.contains('is-row-hidden') === hide) return;
      this.classList.toggle('is-row-hidden', hide);
      if (hide)
        this.querySelectorAll('header-menu details[open]').forEach((d) => {
          d.removeAttribute('open');
          d.querySelector('summary')?.setAttribute('aria-expanded', 'false');
        });
      this.publishOffset();
    }

    publishOffset() {
      const cs = getComputedStyle(this);
      const rem = parseFloat(getComputedStyle(document.documentElement).fontSize) || 10;
      const primary = parseFloat(cs.getPropertyValue('--fs-hdr-primary')) * rem || this.offsetHeight;
      const top = parseFloat(getComputedStyle(this.header).top) || 0;
      const h = Math.round((this.classList.contains('is-row-hidden') ? primary : this.offsetHeight) + top);
      document.documentElement.style.setProperty('--fs-sticky-header-h', `${Math.max(0, h)}px`);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /*
    Search icon: desktop opens / closes the search field inside the card (old site); phones scroll the field back
    into view (it hides while scrolling) and focus it. Without JS the icon is a plain link to /search.
    Support button opens the Support Center dialog (snippets/fs-support-center).
  */
  (() => {
    const wrapper = document.querySelector('.fs-header');
    if (!wrapper) return;
    const toggle = wrapper.querySelector('[data-fs-search-toggle]');
    const box = document.getElementById('FsHeaderSearch');
    const input = box?.querySelector('input[type="search"]');
    const desktop = window.matchMedia('(min-width: 990px)');

    const setSearch = (open) => {
      wrapper.classList.toggle('is-search-open', open);
      toggle?.setAttribute('aria-expanded', String(open));
      if (open) {
        if (typeof wrapper.setRowHidden === 'function') wrapper.setRowHidden(false);
        else wrapper.classList.remove('is-row-hidden');
        requestAnimationFrame(() => input?.focus());
      }
    };

    if (toggle && box && input) {
      toggle.setAttribute('role', 'button');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.addEventListener('click', (event) => {
        event.preventDefault();
        const open = wrapper.classList.contains('is-search-open');
        if (!desktop.matches && !wrapper.classList.contains('is-row-hidden') && !open) {
          input.focus(); // field already on screen under the bar
          return;
        }
        setSearch(!open);
      });
      toggle.addEventListener('keydown', (event) => {
        if (event.code === 'Space') {
          event.preventDefault();
          toggle.click();
        }
      });
      box.addEventListener('keyup', (event) => {
        if (event.code === 'Escape' && wrapper.classList.contains('is-search-open') && !input.value) {
          setSearch(false);
          toggle.focus();
        }
      });
      document.addEventListener('click', (event) => {
        if (!wrapper.classList.contains('is-search-open')) return;
        if (box.contains(event.target) || toggle.contains(event.target)) return;
        if (!input.value) setSearch(false);
      });
    }

  })();

  /*
    Basket count.
    - Dawn's cart notification / drawer / cart page re-render #cart-icon-bubble from sections/cart-icon-bubble.
    - Adds that don't return sections (e.g. the free-sample button) only publish cartUpdate / fire cart:refresh,
      so re-fetch the bubble section for those.
  */
  (() => {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;

    let pending;
    const refresh = () => {
      window.clearTimeout(pending);
      pending = window.setTimeout(async () => {
        try {
          const root = window.Shopify?.routes?.root || '/';
          const res = await fetch(`${root}?sections=cart-icon-bubble`);
          if (!res.ok) return;
          const html = (await res.json())['cart-icon-bubble'];
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const inner = doc.querySelector('.shopify-section');
          if (inner) bubble.innerHTML = inner.innerHTML;
        } catch (e) {
          /* the count catches up on the next page view */
        }
      }, 150);
    };

    document.addEventListener('cart:refresh', refresh);
    const subscribeWhenReady = () => {
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (!event?.cartData?.sections) refresh();
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', subscribeWhenReady);
    } else {
      subscribeWhenReady();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
